import { render } from "./PersonasDetail.vue?vue&type=template&id=354a949e&scoped=true"
import script from "./PersonasDetail.vue?vue&type=script&lang=js"
export * from "./PersonasDetail.vue?vue&type=script&lang=js"

import "./PersonasDetail.vue?vue&type=style&index=0&id=354a949e&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354a949e"]])

export default __exports__